import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import _ from "lodash";
import {bindActionCreators} from "redux";
import {createUserIgnored, deleteUserIgnored} from "../../../../creators/user.userIgnored";
import {reportUser} from "../../../../creators/report";
import {updateCurrentUser} from "../../../../creators/currentUser";
import {createUserFriendsRequest} from "../../../../creators/user.friendsRequest";
import {Button} from "../../../components/Button";
import CtaCannot from "../../../components/CtaCannot";
import {Can} from "../../../../ability-context";
import QuestionCardList from "../../../components/QuestionCardList";
import Subscribe from "../../../components/Subscribe";
import Modal from "../../../components/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserPlus} from "@fortawesome/free-solid-svg-icons";
import {SpinLoader} from "../../../components/Loader";

class ProfileAddFriend extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isFriendRequestPending: this.props.user.isFriendRequestPending,
            toggleFriendshipQuestions: false,
            showQuestion: false
        }

    }
/*
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(_.get(this.props, "history.location.hash") === "#addfriend" ){
            let hash = window.location.hash.replace(/(.*)[#&]addfriend(.*)/, '$1$2');
            if(hash !== ""){
                if(hash.substr(0,1) === "&"){
                    hash = hash.substr(1,hash.length);
                }
                if(hash.substr(0,1) !== "#"){
                    hash = `#${hash}`;
                }
            }
            let newUri = window.location.pathname + window.location.search + hash;
            window.history.replaceState({}, document.title, newUri);
            const element = document.getElementById("btn-add-friend");
            if (element) {
                element.click();
            }
        }
    }*/


    submitFriendDirect() {
        if (!this.state.isFriendRequestPending) {
            let friendRequestQuestions = _.get(this.props.user, "setting.friendRequestQuestions");
            if (friendRequestQuestions) {
                this.setState({toggleFriendshipQuestions: true});
            } else {
                this.props.createUserFriendsRequest(this.props.user._id, {}).then(response => {
                    this.setState({isFriendRequestPending: true});
                }).catch(e => {

                });
            }
        }
    }

    render() {
        let isFriend = this.props.user.isFriend;
        return <Fragment>
            <Can action="create" subject="Friend" passThrough>
                {can => {
                    return can ? (
                        !isFriend && (
                            <div
                                id={`${!this.state.isFriendRequestPending ? "btn-add-friend" : "btn-friend"}`}
                                className={`btn-profile-subnav ${!this.state.isFriendRequestPending && "primary-reverse"}`}
                                onClick={() => this.submitFriendDirect()}>
                                {this.props.userFriendsRequestLoading ? (
                                    <SpinLoader className={"small"}/>
                                ) : (
                                    <Fragment>
                                        <FontAwesomeIcon icon={faUserPlus}/>
                                        {this.state.isFriendRequestPending ? 'En attente' : 'Ami'}
                                    </Fragment>
                                )}
                            </div>
                        )
                    ) : (
                        <CtaCannot action={"addFriend"} isModal={true}
                                   button={
                                       {
                                           id : `${!this.state.isFriendRequestPending ? "btn-add-friend" : "btn-friend"}`,
                                           isBtn: false,
                                           content: <Fragment><FontAwesomeIcon icon={faUserPlus}/> Ami</Fragment>,
                                           className: "btn-profile-subnav primary-reverse"
                                       }
                                   }/>
                    )
                }}
            </Can>
            <Modal toggle={this.state.toggleFriendshipQuestions}
                   handleClose={() => this.setState({toggleFriendshipQuestions: false})}>
                {(this.props.currentUser.customer && this.props.currentUser.customer.subscribed) && !isFriend ? (
                    <Fragment>
                        {this.state.showQuestion ? (
                            <QuestionCardList currentUser={this.props.currentUser}
                                              user={this.props.user}
                                              handleFriendPendingState={() => this.setState({isFriendRequestPending: true})}
                                              handleClose={() => this.setState({toggleFriendshipQuestions: false})}/>
                        ) : (
                            <div className="list-container">
                                <div className="question-card-list start-question">
                                    <div className="question-card-wrapper">
                                        <div className="question-card">
                                            <div className="container">
                                                <div className="column">
                                                    <span
                                                        className="py-16 question-asked">Avant de devenir ami(e), {this.props.user.username} aimerait faire connaissance</span>
                                                    <Button className={"mb-8 mx-8"}
                                                            size={"medium"}
                                                            btnStyle={"primary-reverse"}
                                                            onClick={() => this.setState({showQuestion: true})}
                                                            content={"Commencer !"}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Fragment>
                ) : (
                    <Subscribe handleClose={() => this.setState({toggleFriendshipQuestions: false})}/>
                )}
            </Modal>
        </Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,

        userIgnored: state.userIgnored.data,

        userFriendsRequestLoading: state.userFriendsRequest.loading
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    createUserIgnored,

    reportUser,
    updateCurrentUser,
    deleteUserIgnored,

    createUserFriendsRequest
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAddFriend);